import { render, staticRenderFns } from "./SuggestInput.vue?vue&type=template&id=02e65bc9"
import script from "./SuggestInput.vue?vue&type=script&lang=js"
export * from "./SuggestInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports